module.exports = __webpack_public_path__ + "img/inspiration-5.96c3235.jpg";